import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const HomeAnalyticsLazy = React.lazy(
	() => import(/* webpackChunkName : 'Home' */ './components/HomeAnalytics')
);

export default (store) => {
	return {
		path: 'analytics',
		element: <AsyncLoading component={<HomeAnalyticsLazy />} />,
	};
};
